import * as PIXI from 'pixi.js';
import { config } from './appConfig';
import { containers, stopBg, updateGameSpeed } from './gameUI';
import { instances } from './gameUI';

export class loader {

  animatedLoader = null;
  loadingContainer = null;
  backgroundBlur = null;

  constructor(x, y) {

    this.loadingContainer = new PIXI.Container();
    this.loadingContainer.x = config.logicalWidth / 2;
    this.loadingContainer.y = config.logicalHeight / 2;
    this.loadingContainer.visible = false;

    this.backgroundBlur = new PIXI.Graphics();
    this.backgroundBlur.beginFill(0x000000, 0.9);
    this.backgroundBlur.drawRect(-750, -1750, 1500, 3500);
    this.backgroundBlur.endFill();
    this.backgroundBlur.alpha = 0.6;
    this.backgroundBlur.interactive = true;
    this.loadingContainer.addChild(this.backgroundBlur);
    this.loadingContainer.zIndex = 99;

    //  const mask = new PIXI.Graphics();
    //  mask.beginFill(0xffffff);
    //  mask.drawRect(0, -1800, config.logicalWidth, config.logicalHeight + 3000);
    //  mask.endFill();

    //s  this.loadingContainer.addChild(mask)
    // this.loadingContainer.mask = mask


    const textures = [];
    for (let i = 1; i <= 12; i++) {
      const texture = PIXI.Assets.get(`load${i}`);
      if (texture) {
        textures.push(texture);
      } else {
        // console.warn(`Texture load ${i} not found`);
      }
    }

    if (textures.length > 0) {
      this.animatedLoader = new PIXI.AnimatedSprite(textures);
      this.animatedLoader.x = 0
      this.animatedLoader.y = 0
      this.animatedLoader.anchor.set(0.5);

      this.animatedLoader.animationSpeed = 0.28;
      this.animatedLoader.loop = true;
      this.animatedLoader.play();
      this.animatedLoader.visible = false;
      this.loadingContainer.addChild(this.animatedLoader);
    } else {
      // console.warn('No textures found for the animated loader.');
    }
    window.addEventListener('resize', this.onResize.bind(this));
    containers.bgContainer.addChild(this.loadingContainer)
    this.onResize()
  }

  onResize() {
    // if (window.innerWidth < 500) {

    //   this.loadingContainer.x = 0
    //   const scaleX = window.innerWidth / config.logicalWidth;
    //   this.loadingContainer.scale.set(scaleX, config.minScaleFactor);

    // } else {

    //   this.loadingContainer.x = config.minLeftX;
    //   this.loadingContainer.scale.set(config.minScaleFactor);
    //   this.loadingContainer.y = config.minTopY;
    // }
  }

  showLoader() {
    this.loadingContainer.visible = true
    this.animatedLoader.visible = true;
    stopBg();
    instances.Meter.stopPulsate()
  }

  hideLoader(flag) {
    this.loadingContainer.visible = false
    updateGameSpeed(false, true);

    instances.Meter.startPulsate()
  }
}